import { Component, EventEmitter, Input, Output } from '@angular/core';



interface stopList {
  name:string;
  branch:string;
  title:string;
  address:string;
  floor: string;
  endStop: string;
  capacity: string;
  village:string;
}


interface BoatTrain {
  name:string;
  endStop: string;
  detail: string;
  stopList: stopList[]
}

@Component({
  selector: 'boat-traffic',
  standalone: true,
  template:`
<div class="detail collapse {{ state }}" id="boat">
  <div class="card card-body">
    <a (click)="close()" role="button" aria-expanded="false" aria-controls="boat" class="bt-close">
      <span aria-hidden="true" class="close">×</span>
    </a>
    <div class="site-tt" >避難所資訊</div>
   
      <ul class="box boat">
       
        <li class="titbox">
          <div class="m-title" id="adr1">{{name}}</div>
          
        </li>
        
        <li class="timelist link">
         <a href="https://www.google.com/maps/place/{{lat}},{{lng}}?webviewopendefaultbrowser=true" role="button" target="_blank">
      立即前往
    </a>
        </li>
<li class="timelist link">
         
          <p class="t-number"><span>轄管分局：</span></p>
          <div class="time">
          
            <p class="next"  id="adr2">{{ branch }}</p>
          </div>
          
        </li>
         <li class="timelist link">
         
          <p class="t-number"><span>里別：</span></p>
          <div class="time">
          
            <p class="next"  id="adr3">{{ village }}</p>
          </div>
          
        </li>
        <li class="timelist link">
         
          <p class="t-number"><span>地址：</span></p>
          <div class="time">
          
            <p class="next"  id="adr4">{{ address }}</p>
          </div>
          
        </li>
        <li class="timelist link">
         
          <p class="t-number"><span>地下樓層數：</span></p>
          <div class="time">
          
            <p class="next"  id="adr5">{{ floor }}</p>
          </div>
          
        </li>
         <li class="timelist link">
         
          <p class="t-number"><span>可容納人數：</span></p>
          <div class="time">
          
            <p class="next"  id="adr6">{{ capacity }}</p>
          </div>
          
        </li>
       
      </ul>
   
    
  </div>
</div>
  `
})

export class BoatTrafficComponent {

  

  @Input() name: string = "";
  @Input() title: string = "";
  @Input() branch: string = "";
  @Input() address: string = "";
  @Input() stationId: string = "";
  @Input() floor: string = "";
  @Input() capacity: string = "";
  @Input() village:string="";
  @Input() lat: string = "";
  @Input() lng: string = "";

  @Output() callBack =  new EventEmitter<void>();
  state: string = "";
  ifRoute: boolean = false;
  BoatTrainList: BoatTrain[] = [];
  BoatRoute: BoatTrain;
  endStop:string ="";
  ngAfterViewInit() {
    
  }
  ngOnChanges(){
    this.state = "show";
    
  }
  close(){
    this.callBack.emit();
  }


 

  getRoute(boatTrain:BoatTrain){
    this.ifRoute = true;
    this.BoatRoute = boatTrain;
  }

  back(){
    this.ifRoute = false;
  }
  


}
